export default [
  {
    path: 'consultorias/consultorias',
    name: 'consultorias_consultorias',
    component: () =>
      import('@/views/consultorias/consultorias/views/index.vue'),
  },
  {
    path: 'consultorias/consultorias/crear',
    name: 'consultorias_consultorias_crear',
    component: () =>
      import('@/views/consultorias/consultorias/views/Handle.vue'),
  },
  {
    path: 'consultorias/consultorias/editar/:id',
    name: 'consultorias_consultorias_editar',
    component: () =>
      import('@/views/consultorias/consultorias/views/Handle.vue'),
  },
  {
    path: 'consultorias/consultorias/ver/:id',
    name: 'consultorias_consultorias_ver',
    component: () =>
      import('@/views/consultorias/consultorias/views/See.vue'),
  },
];
